import React from 'react';
import Select from 'react-select';
import find from 'lodash/find';
import _ from 'lodash';

import select from '../FormComponents/select';
import selectTheme from '../FormComponents/selectTheme';
import CustomInput from './customInput';
import useTheme from '../../theme/useTheme';

const CustomSelect = ({
  options,
  form,
  field,
  isClearable,
  onChange,
  value,
  isSearchable,
  // eslint-disable-next-line no-unused-vars
  ...props
}) => {
  const theValue =
    typeof value !== 'undefined'
      ? value
      : find(options, item => (field.value === '' ? field.value === item.value : _.isEqual(item.value, field.value)));

  const { theme } = useTheme();

  return (
    <Select
      {...props}
      isSearchable={isSearchable}
      onChange={
        onChange
          ? onChange
          : option => {
              if (option) {
                form.setFieldValue(field.name, option.value);
              } else {
                form.setFieldValue(field.name, null);
              }
            }
      }
      onMenuClose={() => {
        form.setFieldTouched(field.name);
      }}
      onBlur={() => {
        form.setFieldTouched(field.name);
      }}
      value={theValue}
      isClearable={isClearable}
      options={options}
      styles={select(theme)}
      theme={options => selectTheme(options, theme)}
      components={{ Input: CustomInput }}
      autosize={false}
    />
  );
};

export default CustomSelect;
